import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IClub888IconProps extends ISvgIconProps {

}

export class Club888Icon extends React.Component<IClub888IconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M6.775 7.611a2.376 2.376 0 1 1 -2.376 2.376 2.378 2.378 0 0 1 2.376 -2.376Zm0 3.552a1.176 1.176 0 1 0 -1.176 -1.176 1.178 1.178 0 0 0 1.176 1.176Z"/>
                    <path d="M6.775 11.186a2.376 2.376 0 1 1 -2.376 2.376 2.378 2.378 0 0 1 2.376 -2.376Zm0 3.552a1.176 1.176 0 1 0 -1.176 -1.176 1.178 1.178 0 0 0 1.176 1.176Z"/>
                    <path d="M12.005 7.611a2.376 2.376 0 1 1 -2.376 2.376 2.378 2.378 0 0 1 2.376 -2.376Zm0 3.552a1.176 1.176 0 1 0 -1.176 -1.176 1.178 1.178 0 0 0 1.176 1.176Z"/>
                    <path d="M12.005 11.186a2.376 2.376 0 1 1 -2.376 2.376 2.378 2.378 0 0 1 2.376 -2.376Zm0 3.552a1.176 1.176 0 1 0 -1.176 -1.176 1.178 1.178 0 0 0 1.176 1.176Z"/>
                    <path d="M17.234 7.611a2.376 2.376 0 1 1 -2.376 2.376 2.378 2.378 0 0 1 2.376 -2.376Zm0 3.552a1.176 1.176 0 1 0 -1.176 -1.176 1.178 1.178 0 0 0 1.176 1.176Z"/>
                    <path d="M17.234 11.186a2.376 2.376 0 1 1 -2.376 2.376 2.378 2.378 0 0 1 2.376 -2.376Zm0 3.552a1.176 1.176 0 1 0 -1.176 -1.176 1.178 1.178 0 0 0 1.176 1.176Z"/>
                </g>
            </SvgIcon>
        );
    }
}
